import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconBrandGetAccept(props: IconProps) {
  return (
    <BaseIcon size={40} {...props}>
      <circle cx="9.9" cy="12.3" fill="#F7941E" r="8.7" />
      <path
        d="M22.642 5.542 10.221 17.964l-6.142-5.8 1.442-1.527 4.658 4.399L21.158 4.058l1.484 1.484Z"
        fill="#F7941E"
      />
      <path
        d="M17.373 7.842c.383.643.687 1.338.896 2.074l-8.048 8.048-6.142-5.8 1.442-1.527 4.658 4.399 7.194-7.194Z"
        fill="#fff"
      />
    </BaseIcon>
  );
}
